import { omit } from '@st/utils'

/**
 * Удаляет всякие лишние query параметры из урла после редиректов/перезагрузок страницы
 */
export default defineNuxtRouteMiddleware(async (to) => {
  const nuxtApp = useNuxtApp()

  /**
   * Должно срабатывать только на клиенте при прямом переходе
   * @see https://nuxt.com/docs/guide/directory-structure/middleware#when-middleware-runs
   */
  if (
    import.meta.server ||
    !nuxtApp.isHydrating ||
    !nuxtApp.payload.serverRendered
  ) {
    return undefined
  }

  if (to.query.modal === 'restriction') {
    return navigateTo({ path: to.path, query: omit(to.query, ['modal']) })
  }

  if ('no-redirects' in to.query) {
    return navigateTo({
      path: to.path,
      query: omit(to.query, ['no-redirects']),
    })
  }

  return undefined
})
